import React from "react";
import { useLang } from "@/context/LangContext";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-900 text-slate-300 py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-green-600 text-white">
              <span className="font-display font-bold">T</span>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display font-bold tracking-tight text-white text-lg">
                TERAFI<span className="text-green-400">QUIRO</span>
              </span>
              <span className="mt-0.5 text-[9px] font-semibold tracking-[0.28em] uppercase text-green-400">
                Wellness Center
              </span>
            </span>
          </div>
          <p className="mt-5 text-sm text-slate-400 max-w-md leading-relaxed">
            <span className="italic text-slate-300">Al cuidado de tu cuerpo.</span> TERAFIQUIRO nace con la
            convicción de que cada cuerpo merece atención humana, técnica y empática.
            Combinamos terapia física, rehabilitación y quiropráctica en un solo espacio
            para ofrecerte un tratamiento verdaderamente integral.
          </p>
        </div>

        <div>
          <p className="font-display font-semibold text-white text-sm mb-4">
            Servicios en Pachuca
          </p>
          <ul className="space-y-2 text-sm">
            <li><a href="/servicios/terapia-fisica-pachuca" className="hover:text-green-400">Terapia Física Pachuca</a></li>
            <li><a href="/servicios/quiropractico-pachuca" className="hover:text-green-400">Quiropráctico Pachuca</a></li>
            <li><a href="/servicios/masaje-deportivo-pachuca" className="hover:text-green-400">Masaje Deportivo</a></li>
            <li><a href="/servicios/ozonoterapia-pachuca" className="hover:text-green-400">Ozonoterapia</a></li>
            <li><a href="/servicios/medicina-funcional-pachuca" className="hover:text-green-400">Medicina Funcional</a></li>
            <li><a href="/servicios/tratamientos-faciales-pachuca" className="hover:text-green-400">Tratamientos Faciales</a></li>
          </ul>
        </div>

        <div>
          <p className="font-display font-semibold text-white text-sm mb-4">
            {t.nav.contact}
          </p>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>{t.contact.address}</li>
            <li className="pt-2"><span className="block text-xs text-slate-500 uppercase tracking-wider">Fisio · Quiro</span><a href="https://wa.me/527712141634" className="hover:text-green-400">+52 771 214 1634</a></li>
            <li><span className="block text-xs text-slate-500 uppercase tracking-wider">Alternativas</span><a href="https://wa.me/527711610609" className="hover:text-green-400">+52 771 161 0609</a></li>
            <li><span className="block text-xs text-slate-500 uppercase tracking-wider">Estética</span><a href="https://wa.me/527711290073" className="hover:text-green-400">+52 771 129 0073</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p>© {year} TERAFIQUIRO Wellness Center. {t.footer.copy}</p>
        <p className="italic">{t.footer.tag}</p>
      </div>
    </footer>
  );
};

export default Footer;
